import { render, staticRenderFns } from "./CustomerSubAccountCheckersQueue.vue?vue&type=template&id=506edc3d&"
import script from "./CustomerSubAccountCheckersQueue.vue?vue&type=script&lang=js&"
export * from "./CustomerSubAccountCheckersQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports